import React, { useEffect, useState } from "react"
import { Button, Col, DatePicker, Form, Input, Modal, Row, Select, Space, Upload } from "antd"
import { PreviewImgOrPdf } from "../filingManagement/Preview"
import {
  acceptImgTypes,
  AXIOS_IP_WATER,
  beforeUpload,
  customRequest,
} from "../filingManagement/fileUploadService"
import { CloseOutlined, MinusCircleOutlined, PlusCircleOutlined, PlusOutlined } from "@ant-design/icons"
import { DateTimeFormatSimpleOnly } from "../../models/datetime"
import moment from "moment"

export const MultipleRecords = (props: {
  label: string
  name: string
  required: boolean
  token: string
  maxCount?: number
  rules?: any[]
  defaultValue?: any // 编辑的默认数据
  changeForm?: (v: any) => void
}) => {
  const [fileLists, setFileLists] = useState<any>([])

  const [previewFile, setPreviewFile] = useState<any>() //预览

  // 自定义上传实现
  const customRequestFn = (options: any, index: number) => {
    customRequest(options, AXIOS_IP_WATER, (data: any) => {
      const newurl = {
        fileConfigId: data?.configId,
        fileName: data?.name,
        fileType: data?.type,
        filePath: data?.path,
      }
      const newFileLists = fileLists?.map((v: any, i: number) => {
        return i === index ? {...v, file: [...v.file, newurl]} : v
      })
      setFileLists(newFileLists)
    })
  }

  const handleRemove = (index:number, indexItem: number) => {
    setFileLists(fileLists?.map((v: any, i: number) => {
      return i === index ? 
        {...v, file: v.file?.filter((item: any, indexTwo: number) => indexTwo !== indexItem)} 
        : v
    }))
  }

  useEffect(() => {
    if(props.defaultValue?.length) {
      setFileLists(props.defaultValue)
    } else {
      setFileLists([{date: '', file: []}])
    }
  }, [props.defaultValue])

  useEffect(() => {
    if(!props.changeForm) return
    const list = fileLists?.filter((v: any) => v?.file?.length || v?.date)
    if(props.required) {
      props.changeForm(list.filter((t: any) => t?.date && t.file?.length))
    } else {
      props.changeForm(list)
    }
  }, [fileLists])

  return (
    <>
      <Form.Item
        label={props.label}
        name={props.name}
        rules={[{ required: props.required, ...props.rules }]}
      >
        {fileLists?.map((v: any, index: number) => {
          return ( 
            <Row align="middle" key={index}>
              <Col span={23} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Space>
                  <DatePicker
                    value={v.date}
                    placeholder=" 年 / 月 / 日"
                    format={DateTimeFormatSimpleOnly}
                    allowClear
                    style={{ width: '200px' }}
                    onChange={(d) => {
                      setFileLists(fileLists?.map((v: any, i: number) => i === index ? {...v, date: d ? moment(d) : null} : v))
                    }}
                  />
                  <Upload
                    customRequest={(options) => customRequestFn(options, index)}
                    beforeUpload={(file) => beforeUpload(file, v.file, props.maxCount)}
                    showUploadList={false}
                    maxCount={props.maxCount || 3}
                    accept={acceptImgTypes}
                  >
                    <Button icon={<PlusOutlined />}>{'上传图片'}</Button>
                  </Upload>
                </Space>
                <Space>
                  {index == 0 ? 
                    <PlusCircleOutlined 
                      onClick={() => {
                        setFileLists([...fileLists, {date: '', file: []}])
                      }}
                      style={{
                        color: '#1684FC',
                        fontSize: '20px',
                      }} 
                    /> :
                    <MinusCircleOutlined
                      onClick={() => {
                        setFileLists(fileLists?.filter((v: any, i: number) => i !== index))
                      }} 
                      style={{
                        color: '#FF4C4C',
                        fontSize: '20px',
                      }} 
                    />
                  }
                </Space>
              </Col>
              <Col span={24} style={{ marginTop: 10, display: "flex",alignItems: "center", cursor: "pointer" }}>
                {v?.file?.length > 0 &&
                  v?.file?.map((m: any, indexItem: number) => {
                    return (
                      <span
                        key={indexItem}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          paddingRight: 10,
                          marginBottom: 10,
                        }}
                      >
                        <span style={{ paddingRight: 10 }}>
                          {m.fileName}{" "}
                          <a
                            style={{ paddingLeft: 10 }}
                            onClick={() => setPreviewFile(m)}
                          >
                            查看
                          </a>
                        </span>
                        <CloseOutlined
                          style={{
                            position: "relative",
                            top: 2,
                            color: "rgb(161 161 161)",
                          }}
                          onClick={() => {
                            handleRemove(index, indexItem)
                          }}
                        />
                      </span>
                    )
                  })}
              </Col>
            </Row>
          )
        })}
      </Form.Item>

      <PreviewImgOrPdf
        token={props.token}
        AXIOS_IP={AXIOS_IP_WATER}
        file={previewFile}
        onClose={() => setPreviewFile(null)}
      />
    </>
  )
}
